// NOTE: We have two separate filter arrays in order
// to provide more flexibility in the UI.
//
// emailFilters is explicitely used in the segment builder
// since it makes sense to specify "been ..."  when creating a segment.
//
// the default export helps us specify "have ..." when viewing a segment.

export const FILTERS = Object.freeze(
  [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'dropped',
    'converted',
    'bounced',
    'failed',
    'spammed',
    'unsubscribed',
  ].map((filter) => `${filter}_email`),
);

export const SUBJECT_EMAIL_FILTERS = Object.freeze(
  [
    'been sent',
    'been delivered',
    'been opened',
    'been clicked',
    'been suppressed',
    'converted',
    'bounced',
    'failed to deliver',
    'been marked as spam',
    'caused unsubscribe',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);

export const NON_SUBJECT_EMAIL_FILTERS = Object.freeze(
  [
    'been sent',
    'been delivered',
    'opened',
    'clicked',
    'suppressed',
    'converted',
    'bounced',
    'failed to receive',
    'spammed',
    'unsubscribed',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);

export const IS_SUBJECT_EMAIL_FILTERS = Object.freeze(
  [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'suppressed',
    'converted',
    'bounced',
    'failed to deliver',
    'marked as spam',
    'unsubscribed',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);

export const IS_NON_SUBJECT_EMAIL_FILTERS = Object.freeze(
  [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'suppressed',
    'converted',
    'bounced',
    'failed to receive',
    'spammed',
    'unsubscribed',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);
